import { useToast } from 'hooks/useToast';
import { apiClient } from 'api';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export interface JdQualificationsPayload {
  assessment_id: string;
  [key: string]: string;
}

/**
 * Hook for updating JD qualification descriptions via personality-qualification endpoint
 */
export const useJdQualificationsEdit = (assessmentId: string | null) => {
  const queryClient = useQueryClient();
  const { openToast } = useToast();

  const patchMutation = useMutation({
    mutationFn: async (payload: JdQualificationsPayload) => {
      const response = await apiClient.patch('/assessment/personality-qualification/', payload);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['personalityQualifications', assessmentId] });
      openToast({
        show: true,
        heading: "Edit Successful",
        text: "Qualifications edited successfully!",
        type: "info",
        timeOut: 5000,
      });
    },
    onError: (err: any) => {
      const errorMessage = err.response?.data?.message || 'Failed to update qualifications';
      openToast({
        show: true,
        heading: "Sorry",
        text: errorMessage,
        type: "error",
        timeOut: 5000,
      });
    },
  });

  return {
    submitJdQualifications: patchMutation.mutate,
    isSubmitting: patchMutation.isPending,
  };
};
